import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  update(attrs) {
    const url = apiRoutes.authUpdateRealEstateAgentPath();

    return FetchHelpers.post(url, attrs);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/auth/RealEstateAgentRepository.js